import styled from "styled-components";

export const CtaWidgetContainer = styled.div`
  display: grid;
  grid-template-columns: 30% 1fr;
  width: 366px;
  height: 185px;
  padding: 20px 10px 10px 20px;
  gap: 20px;
  flex-shrink: 0;
  border-radius: 10px;
  border: ${({ containerBorderColor }) =>
    containerBorderColor ? `1px solid ${containerBorderColor}` : "none"};
  background: ${({ containerBackgroundColor }) =>
    containerBackgroundColor || "var(--primary-dark-600)"};

  @media (min-width: 2560px) {
    width: 380px;
    height: 220px;
    padding: 20px 10px 30px 20px;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 115px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;

  background-color: ${({ imageBackgroundColor }) =>
    imageBackgroundColor || "var(--primary-dark-500)"};
  background-image: ${({ image }) => (image ? `url(${image})` : "none")};
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Title = styled.p`
  color: ${({ titleTextColor }) => titleTextColor || "var(--primary-white)"};
  font-size: var(--fs-lg);
  font-weight: 600;
`;

export const Description = styled.p`
  color: ${({ descriptionTextColor }) => descriptionTextColor || "var(--primary-dark-200)"};
  font-size: var(--fs-base);
  line-height: var(--lh-base);
`;

export const CtaButton = styled.button`
  display: flex;
  max-width: fit-content;
  margin-top: 18px;
  padding: 11px 18px;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  font-weight: 500;
  font-size: var(--fs-base);
  color: ${({ ctaButtonTextColor }) => ctaButtonTextColor || "white"};

  background: ${({ ctaButtonBackgroundColor }) =>
    ctaButtonBackgroundColor || "var(--accent-primary)"};
  border: none;
  border-radius: 4px;

  transition: all 0.3s ease;
  &:hover {
    transform: scale(1.05);
  }
`;
